import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function QuoteForm() {
  return <section id="quote" className="bg-primary/5 py-16 md:py-24 relative overflow-hidden" data-id="element-86">
      <div className="container max-w-screen-2xl relative z-10" data-id="element-87">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-24" data-id="element-88">
          <div data-id="element-89">
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4" data-id="element-90">
              Ready to Improve Your Property?
            </h2>
            <p className="text-lg text-muted-foreground mb-8" data-id="element-91">
              Submit the form today for a fast, free quote from Hauser's
              Complete Care Inc and discover how we can assist you.
            </p>

            <div className="space-y-6" data-id="element-92">
              <div className="flex items-start gap-4" data-id="element-93">
                <div className="mt-1 bg-primary/10 p-3 rounded-lg text-primary" data-id="element-94">
                  <MapPin className="h-6 w-6" data-id="element-95" />
                </div>
                <div data-id="element-96">
                  <h3 className="font-bold text-lg" data-id="element-97">Service Area</h3>
                  <p className="text-muted-foreground" data-id="element-98">
                    Lancaster, Depew, Cheektowaga, West Seneca, Williamsville,
                    Amherst, and Clarence NY.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-99">
                <div className="mt-1 bg-primary/10 p-3 rounded-lg text-primary" data-id="element-100">
                  <Phone className="h-6 w-6" data-id="element-101" />
                </div>
                <div data-id="element-102">
                  <h3 className="font-bold text-lg" data-id="element-103">Call Us</h3>
                  <p className="text-muted-foreground" data-id="element-104">(555) 123-4567</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-105">
                <div className="mt-1 bg-primary/10 p-3 rounded-lg text-primary" data-id="element-106">
                  <Clock className="h-6 w-6" data-id="element-107" />
                </div>
                <div data-id="element-108">
                  <h3 className="font-bold text-lg" data-id="element-109">Business Hours</h3>
                  <p className="text-muted-foreground" data-id="element-110">
                    Mon-Fri: 8am - 6pm
                    <br data-id="element-111" />
                    Sat: 9am - 2pm
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background rounded-2xl p-8 shadow-lg border border-border/50" data-id="element-112">
            <h3 className="text-2xl font-bold mb-6" data-id="element-113">Get Your Free Quote</h3>
            <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-114">
              <div className="grid grid-cols-2 gap-4" data-id="element-115">
                <div className="space-y-2" data-id="element-116">
                  <label htmlFor="firstName" className="text-sm font-medium" data-id="element-117">
                    First Name
                  </label>
                  <input id="firstName" type="text" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="John" data-id="element-118" />
                </div>
                <div className="space-y-2" data-id="element-119">
                  <label htmlFor="lastName" className="text-sm font-medium" data-id="element-120">
                    Last Name
                  </label>
                  <input id="lastName" type="text" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="Doe" data-id="element-121" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-122">
                <label htmlFor="email" className="text-sm font-medium" data-id="element-123">
                  Email
                </label>
                <input id="email" type="email" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="john@example.com" data-id="element-124" />
              </div>

              <div className="space-y-2" data-id="element-125">
                <label htmlFor="phone" className="text-sm font-medium" data-id="element-126">
                  Phone
                </label>
                <input id="phone" type="tel" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="(555) 123-4567" data-id="element-127" />
              </div>

              <div className="space-y-2" data-id="element-128">
                <label htmlFor="service" className="text-sm font-medium" data-id="element-129">
                  Service Needed
                </label>
                <select id="service" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" data-id="element-130">
                  <option value="" data-id="element-131">Select a service...</option>
                  <option value="landscape-design" data-id="element-132">
                    Landscape Installation & Design
                  </option>
                  <option value="lawn-care" data-id="element-133">Lawn Care & Maintenance</option>
                  <option value="sod-seeding" data-id="element-134">Sod & Seeding</option>
                  <option value="snowplowing" data-id="element-135">
                    Commercial & Residential Snowplowing
                  </option>
                  <option value="hardscaping" data-id="element-136">Hardscaping</option>
                  <option value="cleanup" data-id="element-137">Spring / Fall Clean Up</option>
                  <option value="grading" data-id="element-138">Grading & Resloping</option>
                  <option value="commercial" data-id="element-139">Commercial Landscape</option>
                  <option value="dumpster" data-id="element-140">Dumpster Rentals</option>
                  <option value="other" data-id="element-141">Other</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-142">
                <label htmlFor="message" className="text-sm font-medium" data-id="element-143">
                  Property Details & Message
                </label>
                <textarea id="message" className="flex min-h-[120px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="Tell us about your property and what you need help with..." data-id="element-144"></textarea>
              </div>

              <button type="submit" className="inline-flex h-10 w-full items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" data-id="element-145">
                Request Free Quote
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}